import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { NotificationSMSAction } from '../../../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../../../pipes/highlight-variables.pipe';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-notification-sms-action',
  imports: [FlowActionCardComponent, MatDividerModule, HighlightVariablesPipe],
  templateUrl: './flow-notification-sms-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowNotificationSmsActionComponent {
  readonly data = input.required<NotificationSMSAction>();
}
